export type ApiErrorKind =
  | 'network'
  | 'unauthorized'
  | 'forbidden'
  | 'not-found'
  | 'validation'
  | 'rate-limited'
  | 'server'
  | 'unknown';

export class ApiError extends Error {
  constructor(
    public readonly kind: ApiErrorKind,
    public readonly status: number | null,
    public readonly detail: string | string[] | null,
    public readonly requestId?: string,
  ) {
    super(`API error: ${kind}`);
    this.name = 'ApiError';
  }
}

export function statusToErrorKind(status: number): ApiErrorKind {
  switch (status) {
    case 400:
    case 409:
    case 422:
      return 'validation';
    case 401:
      return 'unauthorized';
    case 403:
      return 'forbidden';
    case 404:
      return 'not-found';
    case 429:
      return 'rate-limited';
    case 500:
    case 502:
    case 503:
      return 'server';
    default:
      return 'unknown';
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!isApiError(error)) return fallback;
  const { detail } = error;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const message = detail.filter(Boolean).join(', ');
    if (message) return message;
  }
  return fallback;
}
